import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Table } from 'reactstrap'

/* eslint-disable */
import { observer, inject } from 'mobx-react'
/* eslint-enable */

import EditTableRow from './partials/EditTableRow'

import Container from '../../partials/Container'

import style from './style'
import access from '../../../../utils/access'
import user from '../../../../utils/user'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

const PAYMENT_TYPE = [
  { name: 'paypal', label: 'PayPal' },
  { name: 'crypto', label: 'Crypto' },
  { name: 'wire', label: 'Bankwire', comment: 'Email us your bank details' }
]

const CRYPTO_TYPES = [
  { short: 'btc', name: 'Bitcoin' },
  // { short: 'btg', name: 'Bitcoin Gold' },
  // { short: 'bch', name: 'Bitcoin Coin' },
  { short: 'eth', name: 'Ethereum' },
  { short: 'ltc', name: 'Litecoin' }
  // { short: 'etc', name: 'Ethereum Classic' },
  // { short: 'doge', name: 'DOGE' }
]

@inject('Application', 'Motd', 'Community', 'Payment', 'Auth', 'User', 'Config')
@observer
export class AccountDetails extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: false,
        field: null,
        value: ''
      },
      motd: {
        id: '123',
        content: '',
        scripts: ''
      }
    }
  }

  componentWillMount () {
    const comId = this.props.match.params.comId
    const _findCommunity = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findCommunity()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : []),
          this.props.Application.getApplication(comId),
          this.props.Payment.getMethod(comId),
          this.props.Motd.getMotd(comId)
        ]).catch(() => this.props.history.push(`/dashboard/community`))
      }, 500)
    }

    _findCommunity()
  }

  onWysiwygChange (value) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        value: value
      }
    })
  }

  onInputChange (...args) {
    console.log(args)
    if (args.length > 1) {
      const e = args[1]
      return this.setState({
        ...this.state,
        editor: {
          ...this.state.editor,
          value: {
            ...this.state.editor.value,
            [e.target.name]: e.target.value
          }
        }
      })
    }

    const e = args[0]
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        value: e.target.type === 'checkbox' ? e.target.checked : e.target.value
      }
    })
  }

  onFormSubmit (type, e) {
    e.preventDefault()

    if (type === 'motd') {
      this.props.Motd.patchMotd(
        this.props.match.params.comId,
        this.state.editor.field,
        this.state.editor.value
      ).then(() => {
        this.setState({
          ...this.state,
          editor: {
            ...this.state.editor,
            active: false
          }
        })
      })
    } else if (type === 'community') {
      this.props.Community.patchCommunity(
        this.props.match.params.comId,
        this.state.editor.field,
        this.state.editor.value
      ).then(() => {
        this.setState({
          ...this.state,
          editor: {
            ...this.state.editor,
            active: false
          }
        })
      })
    } else if (type === 'payment') {
      this.props.Payment.putMethod(this.props.match.params.comId, {
        ...(() => {
          const paymentType = PAYMENT_TYPE[+this.state.editor.value.paymentType]
          const cryptoType = CRYPTO_TYPES[+this.state.editor.value.cryptoType]

          return {
            type:
              paymentType.name === 'crypto'
                ? cryptoType.short
                : paymentType.name,
            ...(paymentType.name !== 'wire'
              ? { address: this.state.editor.value.paymentAddress }
              : {})
          }
        })()
      }).then(() => {
        this.setState({
          ...this.state,
          editor: {
            ...this.state.editor,
            active: false
          }
        })
      })
    }
  }

  onTRMouseOver (name, e) {
    const nState = Object.keys(this.state).reduce((state, key) => {
      state[key] = {
        ...this.state[key],
        isHover: !!(key === name && !this.state[key].isHover)
      }
      return state
    }, {})

    this.setState(nState)
  }

  onTRClick (type, name, e) {
    const comId = this.props.match.params.comId
    const state =
      type === 'community'
        ? this.props.Community.all.slice().find(c => c.id === comId)
        : type === 'payment'
          ? (() => {
            const paymentMethod = this.props.Payment.methods[comId] || {}
            const cryptoType = CRYPTO_TYPES.find(
                ct => paymentMethod && ct.short === paymentMethod.type
              )
            const paymentTypeShort = cryptoType
                ? `crypto`
                : (paymentMethod || {}).type

            const paymentTypeIndex = PAYMENT_TYPE.findIndex(
                pt => pt.name === paymentTypeShort
              )
            const cryptoTypeIndex = CRYPTO_TYPES.findIndex(
                ct => paymentMethod && ct.short === paymentMethod.type
              )

            return {
              method: {
                paymentType: paymentTypeIndex < 0 ? 0 : paymentTypeIndex,
                cryptoType: cryptoTypeIndex < 0 ? 0 : cryptoTypeIndex,
                paymentAddress: paymentMethod.address
              }
            }
          })()
          : this.props.Motd.all[comId]

    e.preventDefault()

    console.log(state)
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        active: !this.state.editor.active,
        field: name,
        value: state[name]
      }
    })
  }

  onRenderClick (e) {
    e.preventDefault()

    this.props.Motd.postMotd(this.props.match.params.comId)
  }

  render () {
    const comId = this.props.match.params.comId
    const community =
      this.props.Community.all.slice().find(a => a.id === comId) || {}

    const userGroups = (this.props.Community.groups[comId] || [])
      .slice()
      .reduce(
        (arr, g) => [
          ...arr,
          ...(g.users.includes(this.props.Auth.token.userId) ? [g] : [])
        ],
        []
      )
    const userPerms = user.parsePermList({ groups: userGroups })

    const application = this.props.Application.all
      .slice()
      .find(a => a.comId === comId) || { pending: true }

    const comSettingsOrAdminPermissions =
      access.comSettings(userPerms) ||
      access.adminCom(this.props.User.me.permissions || {})

    const approvedComSettingsOrAdminPerms = !!(
      (access.comSettings(userPerms) && application.pending) ||
      access.adminCom(this.props.User.me.permissions || {})
    )

    const theme = THEME_LIST[this.props.Config.theme]

    const paymentMethod = this.props.Payment.methods[comId] || {}
    const cryptoType = CRYPTO_TYPES.find(
      ct => paymentMethod && ct.short === paymentMethod.type
    )
    const paymentTypeShort = cryptoType ? `crypto` : (paymentMethod || {}).type
    const paymentType = PAYMENT_TYPE.find(pt => pt.name === paymentTypeShort)

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <h2 className={css(style.headers.h2)}>Community Details</h2>
            <Table
              responsive
              className={css(
                style.table.table,
                style[theme.name] ? style[theme.name].table.table : null
              )}
            >
              <thead>
                <tr>
                  <th
                    width={`20%`}
                    className={css(
                      style.table.th,
                      style[theme.name] ? style[theme.name].table.th : null
                    )}
                  />
                  <th
                    className={css(
                      style.table.th,
                      style[theme.name] ? style[theme.name].table.th : null
                    )}
                  />

                  <th
                    width={`100px`}
                    className={`d-none d-md-table-cell ${css(
                      style.table.th,
                      style[theme.name] ? style[theme.name].table.th : null
                    )}`}
                  />
                </tr>
              </thead>
              <tbody>
                <RenderTableRow
                  title={`Community Name`}
                  name={`name`}
                  content={community.name}
                  // onMouseOver={this.onTRMouseOver.bind(this, 'communityName')}
                  onClick={this.onTRClick.bind(this, 'community', 'name')}
                  editComponent={() => (
                    <EditTableRow
                      title={`name`}
                      onInputChange={this.onInputChange.bind(this)}
                      onFormSubmit={this.onFormSubmit.bind(this, 'community')}
                      onCancelClick={this.onTRClick.bind(
                        this,
                        'community',
                        'name'
                      )}
                      content={[
                        {
                          type: 'input',
                          label: 'name',
                          name: 'name',
                          value: community.name
                        }
                      ]}
                      staticContext={this.props.staticContext}
                    />
                  )}
                  editable={approvedComSettingsOrAdminPerms}
                  editor={this.state.editor}
                />
                <RenderTableRow
                  title={`Motd Name`}
                  name={`seo`}
                  content={`motd.vppgamingnetwork.com/${community.seo}`}
                  // onMouseOver={this.onTRMouseOver.bind(this, 'cummunityUrl')}
                  onClick={this.onTRClick.bind(this, 'community', 'seo')}
                  editComponent={() => (
                    <EditTableRow
                      title={`url`}
                      onInputChange={this.onInputChange.bind(this)}
                      onFormSubmit={this.onFormSubmit.bind(this, 'community')}
                      onCancelClick={this.onTRClick.bind(
                        this,
                        'community',
                        'seo'
                      )}
                      content={[
                        {
                          type: 'input',
                          label: 'url',
                          name: 'seo',
                          value: community.seo
                        }
                      ]}
                    />
                  )}
                  editable={access.adminCom(
                    this.props.User.me.permissions || {}
                  )}
                  editor={this.state.editor}
                />
                <RenderTableRow
                  title={`Enabled`}
                  name={`active`}
                  content={community.active ? `True` : `False`}
                  // onMouseOver={this.onTRMouseOver.bind(this, 'enabled')}
                  onClick={this.onTRClick.bind(this, 'community', 'active')}
                  editComponent={() => (
                    <EditTableRow
                      title={`active`}
                      onInputChange={this.onInputChange.bind(this)}
                      onFormSubmit={this.onFormSubmit.bind(this, 'community')}
                      onCancelClick={this.onTRClick.bind(
                        this,
                        'community',
                        'active'
                      )}
                      content={[
                        {
                          type: 'checkbox',
                          label: 'active',
                          showLabel: true,
                          name: 'active',
                          value: this.state.editor.value
                        }
                      ]}
                    />
                  )}
                  editable={access.adminCom(
                    this.props.User.me.permissions || {}
                  )}
                  editor={this.state.editor}
                />
                <RenderTableRow
                  title={`Community Url`}
                  name={`url`}
                  content={community.url}
                  // onMouseOver={this.onTRMouseOver.bind(this, 'contentUrl')}
                  onClick={this.onTRClick.bind(this, 'community', 'url')}
                  editComponent={() => (
                    <EditTableRow
                      title={`url`}
                      onInputChange={this.onInputChange.bind(this)}
                      onFormSubmit={this.onFormSubmit.bind(this, 'community')}
                      onCancelClick={this.onTRClick.bind(
                        this,
                        'community',
                        'url'
                      )}
                      content={[
                        {
                          type: 'input',
                          label: 'url',
                          name: 'url',
                          value: community.url
                        }
                      ]}
                    />
                  )}
                  editable={approvedComSettingsOrAdminPerms}
                  editor={this.state.editor}
                />
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row>
          <Col>
            <h2 className={css(style.headers.h2)}>Payment</h2>
            <Table
              responsive
              className={css(
                style.table.table,
                style[theme.name] ? style[theme.name].table.table : null
              )}
            >
              <thead>
                <tr>
                  <th
                    width={`20%`}
                    className={css(
                      style.table.th,
                      style[theme.name] ? style[theme.name].table.th : null
                    )}
                  />
                  <th
                    className={css(
                      style.table.th,
                      style[theme.name] ? style[theme.name].table.th : null
                    )}
                  />

                  <th
                    width={`100px`}
                    className={`d-none d-md-table-cell ${css(
                      style.table.th,
                      style[theme.name] ? style[theme.name].table.th : null
                    )}`}
                  />
                </tr>
              </thead>
              <tbody>
                <RenderTableRow
                  title={`Payment`}
                  name={`method`}
                  content={
                    cryptoType
                      ? cryptoType.name
                      : paymentType ? paymentType.label : ''
                  }
                  // onMouseOver={this.onTRMouseOver.bind(this, 'communityName')}
                  onClick={this.onTRClick.bind(this, 'payment', 'method')}
                  editor={this.state.editor}
                  editComponent={() => (
                    <EditTableRow
                      title={`Payment`}
                      onInputChange={this.onInputChange.bind(this, 'payment')}
                      onFormSubmit={this.onFormSubmit.bind(this, 'payment')}
                      onCancelClick={this.onTRClick.bind(
                        this,
                        'payment',
                        'method'
                      )}
                      content={[
                        {
                          type: 'selector',
                          label: 'Payment Type',
                          name: 'paymentType',
                          value: this.state.editor.value.paymentType,
                          options: PAYMENT_TYPE,
                          showLabel: true
                        },
                        ...(+this.state.editor.value.paymentType === 2
                          ? [
                            {
                              type: 'bNote',
                              style: 'italic',
                              value:
                                  'Note: Please, email us your bank details.'
                            }
                          ]
                          : []),
                        ...(+this.state.editor.value.paymentType === 1
                          ? [
                            {
                              type: 'selector',
                              label: 'Crypto Type',
                              name: 'cryptoType',
                              value: this.state.editor.value.cryptoType,
                              options: CRYPTO_TYPES.map(ct => ({
                                label: ct.name
                              })),
                              showLabel: true
                            },
                            {
                              type: 'input',
                              label: 'Crypto Address',
                              name: 'paymentAddress',
                              value: this.state.editor.value.paymentAddress,
                              showLabel: true
                            }
                          ]
                          : []),
                        ...(+this.state.editor.value.paymentType === 0
                          ? [
                            {
                              type: 'input',
                              label: 'Payment Address',
                              name: 'paymentAddress',
                              value: this.state.editor.value.paymentAddress,
                              showLabel: true
                            },
                            {
                              type: 'bNote',
                              style: 'italic',
                              value:
                                  'Note: Please, make sure you enter valid PayPal email.'
                            }
                          ]
                          : [])
                      ]}
                    />
                  )}
                  editable={comSettingsOrAdminPermissions}
                />
                <RenderTableRow
                  title={`eCPM`}
                  name={`eCPM`}
                  content={community.eCPM || 0 + ''}
                  // onMouseOver={this.onTRMouseOver.bind(this, 'communityName')}
                  onClick={this.onTRClick.bind(this, 'communiy', 'eCPM')}
                  editComponent={() => (
                    <EditTableRow
                      title={`eCPM`}
                      onInputChange={this.onInputChange.bind(this)}
                      onFormSubmit={this.onFormSubmit.bind(this, 'community')}
                      onCancelClick={this.onTRClick.bind(
                        this,
                        'community',
                        'eCPM'
                      )}
                      content={[
                        {
                          type: 'input',
                          label: 'eCPM',
                          name: 'eCPM',
                          value: community.eCPM || 0
                        }
                      ]}
                    />
                  )}
                  editable={access.adminCom(
                    this.props.User.me.permissions || {}
                  )}
                  editor={this.state.editor}
                />
                {!access.adminCom(
                  this.props.User.me.permissions || {}
                ) ? null : (
                  <RenderTableRow
                    title={`spotX`}
                    name={`spotxId`}
                    content={(community.spotxId || '<not set>') + ''}
                    // onMouseOver={this.onTRMouseOver.bind(this, 'communityName')}
                    onClick={this.onTRClick.bind(this, 'community', 'spotxId')}
                    editComponent={() => (
                      <EditTableRow
                        title={`spotX`}
                        onInputChange={this.onInputChange.bind(this)}
                        onFormSubmit={this.onFormSubmit.bind(this, 'community')}
                        onCancelClick={this.onTRClick.bind(
                          this,
                          'community',
                          'spotxId'
                        )}
                        content={[
                          {
                            type: 'input',
                            label: 'spotX',
                            name: 'spotxId',
                            value: community.spotxId
                          }
                        ]}
                      />
                    )}
                    editable={access.adminCom(
                      this.props.User.me.permissions || {}
                    )}
                    editor={this.state.editor}
                  />
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
        <RenderMotdTable
          theme={theme}
          isAllowed={access.adminCom(this.props.User.me.permissions || {})}
          onContentClick={this.onTRClick.bind(this, 'motd', 'content')}
          onScriptClick={this.onTRClick.bind(this, 'motd', 'scripts')}
          onFormSubmit={this.onFormSubmit.bind(this, 'motd')}
          onInputChange={this.onInputChange.bind(this)}
          onWysiwygChange={this.onWysiwygChange.bind(this)}
          editor={this.state.editor}
          motd={this.props.Motd.all[comId] || {}}
          onRenderClick={this.onRenderClick.bind(this)}
        />
      </Container>
    )
  }
}

const RenderMotdTable = props => {
  if (!props.isAllowed) {
    return null
  }

  return (
    <Row>
      <Col>
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(style.headers.h2)}>Motd</h2>
          </Col>
          <Col />
          <Col>
            <span
              onClick={props.onRenderClick}
              className={css(style.buttons.button, style.buttons.red)}
            >
              Render
            </span>
          </Col>
        </Row>
        <Table
          responsive
          className={css(
            style.table.table,
            style[props.theme.name] ? style[props.theme.name].table.table : null
          )}
        >
          <thead>
            <tr>
              <th
                width={`20%`}
                className={css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}
              />
              <th
                className={css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}
              />

              <th
                width={`100px`}
                className={`d-none d-md-table-cell ${css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}`}
              />
            </tr>
          </thead>
          <tbody>
            <RenderTableRow
              title={`Content`}
              name={`content`}
              content={'Click to edit'}
              // onMouseOver={this.onTRMouseOver.bind(this, 'communityName')}
              onClick={props.onContentClick}
              editor={props.editor}
              editComponent={() => (
                <EditTableRow
                  title={`Content`}
                  onInputChange={props.onInputChange}
                  onWysiwygChange={props.onWysiwygChange}
                  onFormSubmit={props.onFormSubmit}
                  onCancelClick={props.onContentClick}
                  content={[
                    {
                      type: 'wysiwyg',
                      label: 'Content',
                      name: 'content',
                      value: props.motd.content || '',
                      editor: props.editor
                    }
                  ]}
                />
              )}
              editable={props.isAllowed && +props.motd.statusCode < 400}
            />
            <RenderTableRow
              title={`Scripts`}
              name={`scripts`}
              content={`Click to edit`}
              // onMouseOver={this.onTRMouseOver.bind(this, 'communityName')}
              onClick={props.onScriptClick}
              editComponent={() => (
                <EditTableRow
                  title={`Scripts`}
                  onInputChange={props.onInputChange}
                  onFormSubmit={props.onFormSubmit}
                  onCancelClick={props.onScriptClick}
                  content={[
                    {
                      type: 'input',
                      showLabel: false,
                      name: 'scripts',
                      value: props.motd.scripts || ''
                    }
                  ]}
                />
              )}
              editable={props.isAllowed && +props.motd.statusCode < 400}
              editor={props.editor}
            />
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

const RenderTableRow = props => {
  if (
    props.editor.active &&
    props.editor.field === props.name &&
    props.editComponent
  ) {
    return props.editComponent()
  }

  return (
    <tr
      className={css(
        style.table.tr,
        !props.editable ? style.tableRow.nonEditable : null
      )}
      onMouseEnter={props.onMouseOver}
      onMouseLeave={props.onMouseOver}
      {...(props.editable ? { onClick: props.onClick } : {})}
    >
      <td className={css(style.table.td)}>
        <span className={css(style.tableRow.title)}>{props.title}</span>
      </td>
      <td className={css(style.table.td)}>
        <span className={css(style.tableRow.content)}>
          {props.content || ''}
        </span>
      </td>
      <td className={`d-none d-md-table-cell ${css(style.table.td)}`}>
        <div
          className={`d-flex justify-content-center align-items-center ${css(
            style.tableRow.edit,
            !props.editable ? style.tableRow.nonEditableEdit : null
          )}`}
        >
          <i
            className={`fa fa-pencil`}
            // style={{ opacity: +!!props.state.isHover }}
          />
          <span className={css(style.tableRow.editSpan)}>Edit</span>
        </div>
      </td>
    </tr>
  )
}

export default AccountDetails



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/index.js